<i18n src="./resources/locales.json"></i18n>
<template>
  <v-card class="ecs-business-process light-surface" :style="{ fontFamily: font }">
    <v-card-title>{{ $t('hello', { name }) }}</v-card-title>
    <v-divider class="divider" />
    <v-card-subtitle class="text-right text-right py-2 px-4">{{ email }}</v-card-subtitle>
    <v-card-text>
      <EcsBusinessProcess :businessProcesses="businessProcesses" />
    </v-card-text>
  </v-card>
</template>
<script>
import EcsBusinessProcess from './ecs-business-process/EcsBusinessProcess';
import { mapGetters } from 'vuex';

export default {
  name: 'EcsBusinessProcessScreen',
  components: {
    EcsBusinessProcess
  },
  data() {
    return {
      name: 'John Doe',
      email: 'john.doe@evolveip.net',
      businessProcesses: ['1', '2', '3', '4', '5']
    };
  },
  computed: {
    ...mapGetters(['theme']),
    font() {
      return this.theme.getFont;
    }
  }
};
</script>

<style scoped>
.ecs-business-process {
  height: 100%;
  max-width: 500px;
  margin: auto;
}
.divider {
  background-color: #00000004 !important;
}
.name {
  font-size: 28px;
}
.email {
  justify-content: flex-end;
}
</style>
